import { inject, Injectable } from '@angular/core';
import { Store } from '@softline/core';
import { SOFTLINE_FEATURE_KOMMISSIONIERUNG } from '../kommissionierung.shared';
import { PickingScanRepository } from '../repository/picking-scan.repository';
import { KommissionierungStore } from '../store';
import { Bewekommscan } from '../types/bewekommscan';
import { KommissionsauftragKopf } from '../types/kommissionsauftrag';

/** Downward-only correction of a captured scan: PATCH or DELETE, then reload the Kommission. */
@Injectable({ providedIn: 'root' })
export class ScanCorrectionService {
  readonly #repository = inject(PickingScanRepository);
  readonly #store = inject(Store);

  /** Returns the reloaded Kommission, or null when nothing had to change. */
  async apply(
    idkopfkomm: number,
    scan: Bewekommscan,
    menge: number
  ): Promise<KommissionsauftragKopf | null> {
    const current = scan.artikelMenge.menge;
    if (menge >= current) return null;

    if (menge <= 0) await this.#repository.remove(scan.id);
    else if (scan.scanPalette) return null;
    else await this.#repository.reduce(scan.id, menge);

    return await this.#store.dispatch(
      SOFTLINE_FEATURE_KOMMISSIONIERUNG,
      KommissionierungStore.actions.load,
      { id: idkopfkomm }
    );
  }
}
